import React from 'react';

import styles from './styles.module.scss';

const Loader = () => {
  return <div className={styles.loader}>Loading...</div>;
};

export default Loader;
